export default "__VITE_ASSET__DYbP9JwM__"